require('./backdrop-filter-plugin');

(() => {
  const siteNavigation = document.getElementById('site-navigation');
  const openButton = document.getElementById('site-navigation-open');
  const closeButton = document.getElementById('site-navigation-close');
  // const signUpButton = document.getElementById('site-navigation-signup');
  const megaNav = document.getElementById('site-meganav');
  const searchButton = document.querySelector('.site-header__button--search');
  const searchFormTop = document.querySelector('.main-menu-container .search-form');
  const megaNavChildren = [
    ...document.querySelectorAll('#site-meganav > button'),
    ...document.querySelectorAll('#site-meganav > form'),
    ...document.querySelectorAll('#site-meganav .site-meganav__main li'),
    ...document.querySelectorAll('#site-meganav .site-meganav__sidebar-group'),
  ];
  const mainArea = document.getElementById('primary');

  // Return early if the navigation doesn't exist.
  if (siteNavigation === null
    || openButton === null
    || closeButton === null
    || megaNav === null
    || mainArea === null
    || searchButton === null
    || searchFormTop === null) {
    return;
  }

  const trap = window.focusTrap.createFocusTrap(
    megaNav,
    {
      fallbackFocus: siteNavigation,
      allowOutsideClick: (event) => event.target.id.startsWith('weglot-language'),
    },
  );

  const megaNavTimeline = gsap.timeline({
    paused: true,
    onComplete: () => {
      trap.activate();
    },
    onReverseComplete: () => {
      trap.deactivate();
    },
  })
    .fromTo(
      megaNav,
      {
        display: 'none',
      },
      {
        display: 'grid',
        duration: 0.01,
      },
    )
    .fromTo(
      megaNav,
      {
        opacity: '0',
        backdropFilterBlur: 0,
      },
      {
        opacity: '1',
        backdropFilterBlur: 10,
        duration: 0.15,
      },
    )
    .fromTo(
      megaNavChildren,
      {
        opacity: '0',
      },
      {
        opacity: '1',
        stagger: 0.1,
      },
    );

  const searchButtonTimeline = gsap.timeline({
    paused: true,
  })
    .fromTo(
      searchButton,
      {
        opacity: '1',
      },
      {
        opacity: '0',
        duration: 0.5,
      },
    )
    .fromTo(searchButton, {
      display: 'flex',
    }, {
      display: 'none',
      duration: 0.01,
    })
    .fromTo(searchFormTop, {
      display: 'none',
    }, {
      display: 'flex',
      duration: 0.01,
    })
    .fromTo(
      searchFormTop,
      {
        opacity: '0',
        minWidth: '0',
        width: '0',
        height: '0',
      },
      {
        opacity: '1',
        minWidth: '12rem',
        width: 'auto',
        height: 'auto',
        duration: 0.5,
      },
    );

  const openNavMenu = () => {
    // const button = event.target;
    closeSearch();
    megaNavTimeline.play();
    window.bodyScrollLock.disableBodyScroll(megaNav);

    // if (button.id === 'site-navigation-signup') {
    //   setTimeout(handleEmailSignupFocus, 100);
    // }
  };
  openButton.addEventListener('click', openNavMenu);
  // signUpButton.addEventListener('click', openNavMenu);

  const closeNavMenu = () => {
    megaNavTimeline.reverse();
    window.bodyScrollLock.enableBodyScroll(megaNav);
  };
  closeButton.addEventListener('click', closeNavMenu);

  function openSearch() {
    searchButtonTimeline.play();
    searchButton.setAttribute('aria-expanded', true);
  }

  function closeSearch() {
    searchButtonTimeline.reverse();
    searchButton.setAttribute('aria-expanded', false);
  }

  function handleSearchToggle() {
    const expanded = searchButton.getAttribute('aria-expanded') === 'true';

    if (expanded) {
      closeSearch();
    } else {
      openSearch();
    }
  }
  searchButton.addEventListener('click', handleSearchToggle);

  // function handleEmailSignupFocus() {
  //   const megaNavEmailInput = document.querySelector('.site-meganav input[type="email"]');
  //   if (megaNavEmailInput === null) return;
  //   megaNavEmailInput.focus();
  // }
})();
